// Limited, fixed set of standard unicode emojis for chat reactions — mirrors the
// LiveChat dashboard's EmojiPicker approach (a curated list rendered directly as
// unicode characters, no custom emoji-pack media). The selected character is what
// gets stored in `chat_reactions.emoji_id` and echoed over the `emoji:send` socket
// event, so the DB column/table must be utf8mb4 to hold it.
const REACTION_EMOJIS = [
  '👍',
  '❤️',
  '😂',
  '😮',
  '😢',
  '😡',
  '🎉',
  '🔥',
  '👏',
  '🙏',
  '😍',
  '🤔',
  '😅',
  '😎',
  '🥳',
  '💯',
  '✅',
  '❌',
];

/**
 * Wider set for the composer's emoji button — these are inserted into the
 * message TEXT, so the list is not limited to the reaction set (which has to
 * stay small because every entry is a one-tap reaction target).
 */
export const MESSAGE_EMOJIS = [
  ...REACTION_EMOJIS,
  '🙂',
  '😉',
  '😊',
  '😇',
  '🥰',
  '😘',
  '😜',
  '🤩',
  '🤗',
  '🤝',
  '🙌',
  '👌',
  '✌️',
  '🤞',
  '👋',
  '💪',
  '🧠',
  '👀',
  '😴',
  '😭',
  '😱',
  '🤯',
  '😤',
  '🤒',
  '🤦',
  '🤷',
  '😬',
  '😌',
  '🥲',
  '🫡',
  '🎯',
  '🚀',
  '⭐',
  '✨',
  '⚡',
  '🏆',
  '🎁',
  '📌',
  '📎',
  '📝',
  '📅',
  '⏰',
  '☕',
  '🍕',
  '🎵',
  '💡',
  '🔗',
  '💻',
];

export default REACTION_EMOJIS;
